module.exports = __webpack_public_path__ + "cad30474e3cdcd4cd2567f65f4904cb6.fbx";